import Navigation from '../Navigation';
import Header from './AppBar.style';

const AppBar = () => {
  return (
    <Header>
      <Navigation />
    </Header>
  );
};

export default AppBar;
